import React from "react";
import { cn } from "../lib/utils";

/**
 * ET Full Logo — mark + "Das Einstufungs-Tool" tagline (orange).
 * Used in: Auth ladescreens (Login / Register / Pending), splash, hero panel.
 *
 * Native source aspect-ratio is preserved. Caller controls the *height*;
 * width adjusts naturally — no distortion.
 *
 * Variants:
 * - default (`inverse=false`): dark mark on light backgrounds
 * - inverse (`inverse=true`):  light mark on dark backgrounds
 */
export default function LogoFull({ size = "md", inverse = false, className }) {
  const heightPx = { sm: 80, md: 120, lg: 170, xl: 220 }[size] || 120;
  const src = inverse ? "/et-full-light.png" : "/et-full-dark.png";
  return (
    <div
      className={cn("inline-block select-none", className)}
      data-testid="brand-logo-full"
    >
      <img
        src={src}
        alt="ET. Das Einstufungs-Tool"
        height={heightPx}
        className="block"
        style={{ height: heightPx, width: "auto" }}
        draggable={false}
      />
    </div>
  );
}
